// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__3vh0S"};